import React from 'react';

/**
 * Simple wrapper around a Facebook Page plugin iframe.
 *
 * Props:
 *  - pageUrl: full URL of the Facebook page (default to club profile)
 *  - width: iframe width in pixels
 *  - height: iframe height in pixels
 */
export default function FacebookNews({
  pageUrl = 'https://www.facebook.com/113193304906349',
  width = '100%',   // accept a number (pixels) or a string (percentage)
  height = 1200,
}) {
  // Facebook's plugin requires a numeric width parameter; if we get a
  // percentage we omit it and rely on `adapt_container_width=true`.
  const widthParam = typeof width === 'number' ? `&width=${width}` : '';
  const src =
    'https://www.facebook.com/plugins/page.php?href=' +
    encodeURIComponent(pageUrl) +
    `&tabs=timeline${widthParam}&height=${height}&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

  const [loadFailed, setLoadFailed] = React.useState(false);

  return (
    <div className="facebook-plugin">
      {loadFailed ? (
        <div className="p-6 bg-slate-800 rounded-lg text-center">
          <p className="mb-2 text-sm text-slate-300">
            Unable to load Facebook feed. You can view the page directly.
          </p>
          <a
            href={pageUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-cyan-400 underline"
          >
            {pageUrl}
          </a>
        </div>
      ) : (
        <iframe
          title="Facebook news"
          src={src}
          width={width}
          height={height}
          style={{ border: 'none', overflow: 'hidden' }}
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          onError={() => setLoadFailed(true)}
        ></iframe>
      )}
    </div>
  );
}
